import { useEffect } from 'react';
import { useOtherSettings } from '@namespace/cms/src/hooks/useOtherSettings';
import { COOKIES_KEYS, getCookie } from '@namespace/helpers';

const useInitAmplitude = () => {
  const { amplitude } = useOtherSettings();
  const { apiKey, web } = amplitude;
  const { enabled, defaultEvents } = web;
  const {
    attribution,
    pageViews,
    sessions,
    formInteractions,
    fileDownloads,
    elementInteractions
  } = defaultEvents;

  const isAutomationTestRun = getCookie(COOKIES_KEYS.IS_AUTOMATION_TEST_RUN);

  useEffect(() => {
    if (!enabled || !apiKey || isAutomationTestRun) {
      return undefined;
    }

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src =
      'https://cdn.amplitude.com/libs/analytics-browser-2.11.3-min.js.gz';
    script.async = true;
    script.onload = () => {
      if (window.amplitude) {
        window.amplitude.init(apiKey, {
          autocapture: {
            attribution,
            pageViews,
            sessions,
            formInteractions,
            fileDownloads,
            elementInteractions
          }
        });
      }
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);
};

export default useInitAmplitude;
